<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ShippersView',
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('InventoryModule/Shippers/fetchAllShippers');
      await this.$store.dispatch('Global/fetchAllCountries');
    } catch (e) {
      //
    }
  },
};
</script>

<style scoped></style>
